import { render, staticRenderFns } from "./sharePage.vue?vue&type=template&id=6dbc8354&scoped=true"
import script from "./sharePage.vue?vue&type=script&lang=js"
export * from "./sharePage.vue?vue&type=script&lang=js"
import style0 from "./sharePage.vue?vue&type=style&index=0&id=6dbc8354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbc8354",
  null
  
)

export default component.exports